export * from "./MantineTabler";
